import React from 'preact/compat';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

import colors from '../colors';
import CloseIcon from '../icons/CloseIcon';

const LauncherPopup = ({title, children, open, onClose, Icon, iconColor, sx, fullHeight=false, fullWidth=false}) => {
    return (
        <BackgroundBlocker open={open} opacity={0.9}>
            <Stack
                direction="column"
                sx={{
                    position: 'fixed',
                    top: '20px',
                    left: fullWidth ? '20px': 'max(20px, 50% - 554px)',
                    right: fullWidth ? '20px': 'max(20px, 50% - 554px)',
                    maxHeight: 'calc(100vh - 40px)',
                    bottom: fullHeight ? '20px' : 'none',
                    backgroundColor: colors.featureSelectorBackground,
                    display: open ? 'flex': 'none',
                    borderRadius: '8px',
                    borderColor: colors.featureSelectorBorder,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    zIndex: 200,
                    overflow: 'hidden'
                }}
            >
                <LauncherPopupHeader onClose={onClose} title={title} Icon={Icon} iconColor={iconColor} />
                <Stack
                    direction="column"
                    sx={{
                        padding: '24px',
                        overflowY: 'auto',
                        ...sx
                    }}
                >
                    { children }
                </Stack>
            </Stack>
        </BackgroundBlocker>
    );
};

const BackgroundBlocker = ({open, children, opacity=0.5}) => {
    const opacityHex = Math.floor(opacity * 255).toString(16);
    return (
        <Box
            sx={{
                backgroundColor: colors.backgroundColor + opacityHex,
                position: 'fixed',
                inset: 0,
                overflow: 'hidden',
                display: open ? 'block': 'none',
                zIndex: 90
            }}
        >
            {children}
        </Box>
    );
}

const LauncherPopupHeader = ({onClose, title, Icon, iconColor}) => {
    return (
        <Stack
            direction="row"
            sx={{
                backgroundColor: colors.featureSelectorHeaderBackground,
                justifyContent: 'flex-start',
                alignItems: 'center',
                paddingLeft: '24px',
                paddingRight: '24px',
                fontSize: '32px',
                fontWeight: 600,
                color: colors.primaryText,
                gap: '20px',
                '& h2': {
                    fontSize: 'inherit',
                    paddingTop: '17px',
                    paddingBottom: '13px',
                }
            }}
        >
            {Icon && <Icon fontSize='inherit' style={{ fill: iconColor }} />}
            <Typography variant="h2">
                {title}
            </Typography>
            <Box sx={{flexGrow: 1}} />
            <IconButton
                aria-label="close pop-up"
                onClick={onClose}
                sx={{
                    borderRadius: '8px',
                    padding: 0,
                    '&:hover': {
                        backgroundColor: colors.featureSelectorBackground
                    },
                    '& svg': {
                        width: '48px',
                        height: '48px'
                    }
                }}
            >
                <CloseIcon stroke={colors.primaryText} />
            </IconButton>
        </Stack>
    );
}

export default LauncherPopup;
